module.exports = __webpack_public_path__ + "img/photo_2023-04-22_07-58-00.b54fc912.jpg";